const prefix = 'fal';
const iconName = 'font-case';
const width = 640;
const height = 512;
const aliases = [];
const unicode = 'f866';
const svgPathData = 'M190.9 42.3C188.6 36.1 182.6 32 176 32s-12.6 4.1-14.9 10.3l-160 416c-3.2 8.2 .9 17.5 9.2 20.7s17.5-.9 20.7-9.2L76.2 352H275.8l45.3 117.7c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7l-160-416zM263.5 320H88.5L176 92.6 263.5 320zM624 160c-8.8 0-16 7.2-16 16v34.7C585.4 179.9 549 160 508 160c-68.5 0-124 55.5-124 124v72c0 68.5 55.5 124 124 124c41 0 77.4-19.9 100-50.7V464c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zM416 284c0-50.8 41.2-92 92-92s92 41.2 92 92v72c0 50.8-41.2 92-92 92s-92-41.2-92-92V284z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
